import { CarService } from "../../../service/car-service";

const fetchAllianceDetails = (params) => () => {
    return CarService.fetchAllianceDetails(params);
};

export {
    fetchAllianceDetails
};
